import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import withStyles from 'isomorphic-style-loader/withStyles';
import { Modal } from 'react-bootstrap';
import cx from 'classnames';

import OrderAccept from '../OrderAccept/OrderAccept';
import s from './OrderModal.css';
import { closeOrderModal } from '../../../actions/modalActions';
import { getPendingOrders } from '../../../actions/shop/orders/getPendingOrders';
import SocketContext from '../../SocketContext';
//image
import { FaTimes } from 'react-icons/fa';

class OrderModal extends React.Component {
    static propTypes = {
        closeOrderModal: PropTypes.func,
        orderModal: PropTypes.bool,
        formatMessage: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            orderModalStatus: false
        }
        this.handleBookingCancelled = this.handleBookingCancelled.bind(this);
    }

    static contextType = SocketContext;

    componentDidMount() {
        const { orderModal, userId } = this.props;
        if (orderModal) {
            this.setState({ orderModalStatus: true })
        }

        const socket = this.context;
        if (socket && userId) {
            socket.on(`booking-cancelled-${userId}`, this.handleBookingCancelled);
        }
    }

    componentWillUnmount() {
        const socket = this.context;
        const { userId } = this.props;
        if (socket && userId) {
            socket.removeListener(`booking-cancelled-${userId}`, this.handleBookingCancelled);
        }
    }

    async handleBookingCancelled(data) {
        const { getPendingOrders } = this.props;
        // Re-fetch pending orders. Action `getPendingOrders` automatically closes the modal
        // if `count == 0` when it evaluates the new payload from backend.
        await getPendingOrders();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // // TODO: Remove this debug override for production
        // this.setState({ orderModalStatus: true }); /* Forced open for debug */

        const { orderModal } = nextProps;

        if (orderModal) {
            this.setState({ orderModalStatus: true })
        } else {
            this.setState({ orderModalStatus: false })
        }
    }

    render() {
        const { closeOrderModal } = this.props;
        const { orderModalStatus } = this.state;
        return (
            <Modal show={orderModalStatus} animation={true} onHide={closeOrderModal} className={cx('eatsLoginModal', 'logonMargin', 'timerModal')}>
                <div className={s.sectionBlock}>
                    <Modal.Header>
                        <button type='button' className={cx(s.closeIcon, 'timerCloseModalRTL')} onClick={closeOrderModal}>
                            <FaTimes />
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <OrderAccept />
                    </Modal.Body>
                </div>
            </Modal>
        )
    }
}

const mapState = state => ({
    orderModal: state.modalStatus.isOrderModalOpen,
    userId: state.account?.data?.id
})

const mapDispatch = {
    closeOrderModal,
    getPendingOrders
};

export default withStyles(s)(connect(mapState, mapDispatch)(OrderModal))